import { useContext } from "react";
import { FormikProps } from "formik";
import {
  ItemViewModel,
  SubmitProgramReport,
} from "../../../../../generated/data-contracts";
import { AvisDescriptiveText } from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";
import {
  ProgramReportFiles,
  ProgramReportIdentifiedCreations,
  ProgramReportUnidentifiedCreations,
} from "./sections";

interface IProgramReportFormProps {
  bag: FormikProps<SubmitProgramReport>;
  creationClassesPublic: ItemViewModel[];
  disabled: boolean;
  loading: boolean;
}
export function ProgramReportForm(props: Readonly<IProgramReportFormProps>) {
  const { bag, creationClassesPublic, disabled, loading } = props;
  const { res, ctxPortalSettings } = useContext(AvisContext);

  return (
    <>
      <h2 className="avis-primary-text program-report-title">
        {res("licensees_LicenseReports_PP_Title")}
      </h2>
      <AvisDescriptiveText textKey="portal_LIC_ProgramReport" />
      <ProgramReportIdentifiedCreations
        bag={bag}
        bagField="programReportRows"
        creationClassesPublic={creationClassesPublic}
        disabled={disabled}
        loading={loading}
      />
      <ProgramReportUnidentifiedCreations
        bag={bag}
        bagField="creationsUnidentifiedRows"
        disabled={disabled}
        loading={loading}
        creationClassesPublic={creationClassesPublic}
      />
      <ProgramReportFiles
        bag={bag}
        bagField="dataFileRows"
        disabled={disabled}
        loading={loading}
        allowedFileFormats={ctxPortalSettings?.uploadableDocumentTypes}
      />
    </>
  );
}
